import React, { RefObject } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmploymentImpact from "../../../../components/Icons/EmploymentImpact";
import theme from "../../../../components/styles/theme/theme";

type Props = {
  directJobsSupportedRef: RefObject<HTMLHeadingElement>;
  directToIndirectSuffixRef: RefObject<HTMLHeadingElement>;
  directToIndirectPrefixRef: RefObject<HTMLHeadingElement>;
  indirectJobsSupportedRef: RefObject<HTMLHeadingElement>;
};

export const EmploymentImpactBox: React.FC<Props> = ({
  directJobsSupportedRef,
  directToIndirectSuffixRef,
  directToIndirectPrefixRef,
  indirectJobsSupportedRef,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="employment_impact">
      <div className="employment_title">
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          {t("boxes.employment_impact")}
          <EmploymentImpact
            color={theme.palette.secondary.main}
            height="13px"
            width="18px"
            style={{ width: '25px'}}
          />
        </Typography>
      </div>
      <div className="direct_job_supported">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={directJobsSupportedRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.direct_jobs_supported")}
        </Typography>
      </div>
      <div className="indirect_jobs_supported">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={indirectJobsSupportedRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.indirect_jobs_supported")}
        </Typography>
      </div>
      <div className="direct_to_indirect_job_supported">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
        >
          <Typography
            variant="h4"
            component="span"
            ref={directToIndirectPrefixRef}
          >
            0
          </Typography>
          <Typography variant="h4" component="span">
            :
          </Typography>
          <Typography
            variant="h4"
            component="span"
            ref={directToIndirectSuffixRef}
          >
            0
          </Typography>
        </Typography>

        <Typography variant="body2" component="p">
          {t("boxes.direct_to_indirect_jobs_multiplier")}
        </Typography>
      </div>
    </div>
  );
};
